import { Component, ComponentRef, HostBinding, InjectionToken, Injector, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { distinctUntilChanged } from 'rxjs/operators';
import { AppService } from 'src/services/app.service';
import { Constructor } from 'src/util/types/global';
import { IPage } from '../page.interface';
import { BaseSidebarItem } from './base.sidebar.item';

export const PARENT_COMPONENT = new InjectionToken("PARENT_COMPONENT");

/**
* @ignore - do not show in documentation
*/
@Component({
    selector:    'v-sidebar',
    templateUrl: './v-sidebar.component.haml',
    styleUrls:   ['./v-sidebar.component.sass'],
    standalone:  false,
})
export class VSidebarComponent {
    @HostBinding('attr.role') role = "complementary";
    @Input()
    get visible(): boolean {
        return this.appService.pageService.showRightSidebar;
    }
    set visible(value: boolean) {
        this.appService.pageService.setOption({showRightSidebar: value});
    }

    @ViewChild('host', { read: ViewContainerRef }) host!: ViewContainerRef;

    static instance: VSidebarComponent;
    private mainComponent?: IPage;

    constructor(private appService: AppService, private injector: Injector) {
        VSidebarComponent.instance = this;
        this.appService.$component.pipe(distinctUntilChanged()).forEach(x => {
            this.mainComponent = x;
            //this.visible = this.mainComponent?.showRightSidebar === true;
            this.clear();
        }).catch((e): void => null);
    }

    addItem<T extends BaseSidebarItem<IPage>>(component: Constructor<T>, data: Partial<T>): T;
    addItem<S, T extends BaseSidebarItem<S>>(component: Constructor<T>, data: Partial<T>, sourceComponent: S): T;
    addItem<S, T extends BaseSidebarItem<S | IPage>>(component: Constructor<T>, data: Partial<T> = {}, sourceComponent?: S): T {
        const src = sourceComponent || this.mainComponent;
        const childInjector = Injector.create({ providers: [
            { provide: PARENT_COMPONENT, useValue: src },
            { provide: src.constructor, useValue: src }
        ], parent: this.injector });
        const componentRef = this.host.createComponent<T & {_componentRef: ComponentRef<T>}>(component, { injector: childInjector });
        componentRef.instance._componentRef = componentRef;
        //componentRef.instance._mainComponent = sourceComponent || this.mainComponent;
        return Object.assign(componentRef.instance, data);
    }

    clear() {
        this.host?.clear();
    }
}
